module.exports = __webpack_public_path__ + "static/media/zdhc.d656a036.jpg";